module.exports = __webpack_public_path__ + "static/img/logo-3.657cd06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-3.png
// module id = 7Kzz
// module chunks = 1